// extracted by mini-css-extract-plugin
export default {"regItem":"reg-item__regItem__pVI89","image":"reg-item__image__pdeWw","meta":"reg-item__meta__gngYn","title":"reg-item__title__ZRvQp"};